module.exports = __webpack_public_path__ + "img/tx-kefu.d66e86e3.png";